var render = function render(){var _vm=this,_c=_vm._self._c;return _c('start-page-template',[_c('sign-in-form',{attrs:{"loading":_vm.isLoading,"authentication-error":_vm.formError},on:{"login":_vm.loginHandler}}),_c('cookie-consent-new-design',{staticClass:"cookie-consent"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }